import apiClient from "@/libs/axios";
import router from "@/router";
import { getMessaging, getToken } from "firebase/messaging";
import firebaseApp from "@/libs/firebase";

export const state = {
    currentUser: null,
    loggedIn: false,
    otpSent: false,
    token: null, // Add token to the state
};

export const mutations = {
    setUser(state, { user, token }) {
        state.currentUser = user;
        state.loggedIn = true;
        state.token = token; // Store the token in state
    },
    setOtpSent(state) {
        state.otpSent = true;
    },
    clearUser(state) {
        state.currentUser = null;
        state.loggedIn = false;
        state.otpSent = false;
        state.token = null; // Clear the token on logout
    },
};

export const actions = {
    async register({ commit }, data) {
        await apiClient.get('sanctum/csrf-cookie'); // Ensure CSRF token for Sanctum
        return await apiClient.post('/api/v1/vendor-register', data)
            .then((response) => {
                if (response.status === 200) {
                    commit('setOtpSent', true); // Commit both user and token
                    // commit('successMessage', 'contacts_changed');
                }
            })
            .catch((e) => {
                throw e;
            })
    },
    async logIn({ commit, dispatch }, phone) {
        console.log(phone);
        await apiClient.get('sanctum/csrf-cookie'); // Ensure CSRF token for Sanctum
        // let fcm_token = await dispatch('fetchFcmToken');
        // const response = await apiClient.post('/api/v1/vendor-login', {phone: phone, fcm_token: fcm_token});
        await apiClient.post('/api/v1/vendor-login', {phone: phone})
            .then((response) => {
                // Destructure user and token from the response (assumes API returns them this way)
                // const { user, token } = response.data;
                console.log(response);
                dispatch('profile/profile/basic');
                // Set the token in Axios default headers for subsequent requests
                // apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                commit('setOtpSent', true); // Commit both user and token
            })
            .catch(error => {
                throw error
            });

    },
    async otpVerification({ commit, dispatch }, credentials) {
        try {
            await apiClient.get('/sanctum/csrf-cookie'); // Ensure CSRF token for Sanctum
            let fcm_token = await dispatch('fetchFcmToken')
            const response = await apiClient.post('/api/v1/verify-otp', { ...credentials, fcm_token: fcm_token });

            // Destructure user and token from the response (assumes API returns them this way)
            // const { user, token } = response.data;
            console.log(response);

            localStorage.setItem('user', JSON.stringify(response.data.result));

            // commit('setUser', { user, token }); // Commit both user and token
            commit('setUser', { user: response.data.result, token: response.data.result.token }); // Commit both user and token
            dispatch('profile/profile/basic');
            if (response.data.result.has_data) {
                router.push({ name: 'dashboard' });
            } else {
                router.push({ name: 'setup-account' })
            }

        } catch (e) {
            console.error('OTP verification failed:', e);
            // Handle the error, e.g., by committing an error state or showing a message to the user
            commit('setOtpError', e.response?.data?.message || 'OTP verification failed');
        }
    },
    async fetchUser({ commit, state }) {
        if (state.token) {
            apiClient.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
        }

        try {
            const response = await apiClient.get('api/v1/profile');
            commit('setUser', { user: response.data, token: state.token }); // Use existing token
        } catch {
            commit('clearUser');
        }
    },
    async logOut({ commit }) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .get('api/v1/logout')
            .then((response) => {
                console.log(response);
                commit('clearUser');
                commit('profile/profile/clearProfileData', null, {root: true});
                localStorage.clear();
                sessionStorage.clear();
                // Remove the token from Axios headers on logout
                delete apiClient.defaults.headers.common['Authorization'];
                router.push({ name: 'login' });
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            });
        commit('app/loadingFinish', null, {root: true});
    },

    async fetchFcmToken() {
        // Request Notification Permission
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                console.log('Notification permission granted.');
            } else {
                console.warn('Notification permission denied.');
            }
        });
        try {
            const messaging = getMessaging(firebaseApp);
            const vapidKey = "BAGj3fB5AgCCeQ2lcUN2Mk4lsuMXK6uG19QQHlYUgeNpk_ELvMYVuQrKinaE3ZdG_PITSsa_Lbm9TrZ4nplxGOo"; // Replace with your Firebase VAPID key

            const fcmToken = await getToken(messaging, { vapidKey });
            console.log(fcmToken);
            if (!fcmToken) {
                console.warn("FCM token not available.");
            }

            return fcmToken;
        } catch (error) {
            console.error("Error fetching FCM token:", error);
        }
    },
};

export const getters = {
    loggedIn: (state) => state.loggedIn,
    currentUser: (state) => state.currentUser,
};
